// removed by extract-text-webpack-plugin
module.exports = {"plan":"plan","plan-illustration":"plan-illustration","plan-name":"plan-name","plan-description":"plan-description","plan-subscription-container":"plan-subscription-container","plan-feature":"plan-feature","empty":"empty","plan-vat":"plan-vat","visible":"visible"};


//////////////////
// WEBPACK FOOTER
// ./src/common/component/plans/component/plan/plan.style.sass
// module id = 6AEj
// module chunks = 3